import { useState, useEffect } from 'react'
import { track } from '@amplitude/analytics-browser'
import { useHistory } from 'react-router-dom'
import { setSelectedPageViewAction } from 'src/reducers/course-collection/action'
import { courseEditView } from './components/constants'

export const DEFAULT_COLLECTION_GUID = '00000000-0000-0000-0000-000000000000'

const INITIAL_TABS = [
  { label: 'Mini course', courseEditView: courseEditView.MiniCourses },
  { label: 'Completion', courseEditView: courseEditView.Completion },
  { label: 'Landing page', courseEditView: courseEditView.LandingPage },
]

const PAGE_ROUTES = {
  [courseEditView.MiniCourses]: (courseId, courseCards) => {
    const initialCardId = courseCards?.[0]?.cards?.[0]?.id || ''
    return `/mini-course/${courseId}/page/${initialCardId}`
  },
  [courseEditView.Completion]: courseId =>
    `/mini-course/${courseId}/completion`,
  [courseEditView.LandingPage]: courseId =>
    `/mini-course/${courseId}/landing-page`,
}

export const useTabList = (
  selectedPage,
  dispatch,
  courseId,
  courseCards,
  cardId,
) => {
  const [tabList, setTabList] = useState(INITIAL_TABS)
  const history = useHistory()

  useEffect(() => {
    const getActiveView = () => {
      switch (cardId) {
        case 'landing-page':
          return courseEditView.LandingPage
        case 'completion':
          return courseEditView.Completion
        default:
          return courseEditView.MiniCourses
      }
    }

    const activeView = getActiveView()
    setTabList(prevTabs =>
      prevTabs.map(tab => ({
        ...tab,
        isActive: tab.courseEditView === activeView,
      })),
    )
  }, [selectedPage, cardId])

  const handleTabClick = view => {
    track('course_edit_page', { courseEditView: view })
    dispatch(setSelectedPageViewAction(view))

    const getRoute = PAGE_ROUTES[view]
    if (getRoute) {
      const route = getRoute(courseId, courseCards)
      history.push(route)
    }
  }

  return {
    tabList: tabList.map(tab => ({
      ...tab,
      onClick: () => handleTabClick(tab.courseEditView),
    })),
    handleTabClick,
  }
}
